import React, { useState,useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import ClassStudyChildrens from "../components/classes/ClassStudyChildrens";

import { ChangeSimpleDateString, isObjEmpty,remainDays,GetLocalStorageValue,isNull } from "../../components/common/Common";
import main01Icon from "../../img/icon/icon-center-main01.svg";
import class01Icon from "../../img/icon/icon-center-class-01.svg";
import class02Icon from "../../img/icon/icon-center-class-02.svg";
import class03Icon from "../../img/icon/icon-center-class-03.svg";
import class04Icon from "../../img/icon/icon-center-class-04.svg";

import "../../css/style.css";

//클래스 상세 - 원생관리등
const StudyChildrenSet = () => {
  let { cl_idx } = useParams();
  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //클래스에 등록된 모든 원생의 수업 내역
  const [varClassStudyChildrenList,setClassStudyChildrenList] = useState([]);

  //클래스에 등록된 원생 목록
  const [varClassChildrenList,setClassChildrenList] = useState([]);

  //선택된 수업차수 정보
  const [varClassInfo,setClassInfo] = useState({});

  //전체 수업차수 배열
  const [varClassStudyList,setClassStudyList] = useState([]);

  //전개하여 참여중인 원생을 보여줄 수업차수번호
  const [varClassStudyIndex,setClassStudyIndex] = useState(0);
  const [varClassStudyType,setClassStudyType] = useState(0);
  const [varMainClassStudyType,setMainClassStudyType] = useState(0);
  const [varSelectClassStudyInfo,setSelectClassStudyInfo] = useState({dates:"",index:0});

  //삭제할 원생의 정보 배열
  const [varCanDeleteChildren,setCanDeleteChildren] = useState(false);
  const [varDeleteChildrenList,setDeleteChildrenList] = useState([]);

  //클래스정보호출 - 편집모드
  const GetClassInformation = async(cs_idx) => {
    const sendData = {cl_idx:cl_idx};
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_children_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //클래스정보
        setClassInfo(datas.classes[0]);

        //수업별 원생등록내역
        const childrens = datas.classstudychildrens;
        setClassStudyChildrenList(childrens);

        //클래스에 등록된 정규수업 원생 목록
        const classchildrens = datas.classchildrens;
        setClassChildrenList(classchildrens);

        //클래스 수업 차수 배열
        const studys = datas.classstudys

        for(var i=0; i < studys.length; i++) {
          const studyData = studys[i];
          let childrenArray = childrens.filter(el=>el.cs_idx===studyData.cs_idx);
          studys[i]['childrens'] = childrenArray;
        }
        console.log(studys);
        setClassStudyList(studys);

        //최초 페이지 표시할 때 - 1차수업표시
        let stIndex = 0;
        const selData = studys.find(el=>el.cs_idx === cs_idx);
        if(cs_idx === 0 || isObjEmpty(selData)) {
          setSelectClassStudyInfo({dates:studys[0].cs_date,index:1});
        } else {
          stIndex = selData.cs_index - 1;
          setSelectClassStudyInfo({dates:selData.cs_date,index:selData.cs_index});
        }

        //원생 삭제 표시
        if(remainDays(studys[stIndex].cs_date) > 0) setCanDeleteChildren(true);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    let studyMode = GetLocalStorageValue('class_information',0);
    setClassStudyType(studyMode);
    setMainClassStudyType(studyMode);

    //선택된 수업차수
    let studyIndex = GetLocalStorageValue('class_study_index',0);
    setClassStudyIndex(studyIndex);

    //서버로부터 정보 호출
    GetClassInformation(studyIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  //수업차수 내용 보기
  const onShowStudyInfoHandler = (e,cs_idx) => {
    if(varClassStudyIndex === cs_idx){  //현재 열려 있는 수업차수이므로 닫기
      setClassStudyIndex(0);
      localStorage.setItem('class_study_index',0);
      setSelectClassStudyInfo({dates:"",index:""});
      setCanDeleteChildren(false);
    } else {  //다른 수업차수를 선택한 경우
      setClassStudyIndex(cs_idx);
      localStorage.setItem('class_study_index',cs_idx);
      const selectStudyInfo = varClassStudyList.find(el=>el.cs_idx === cs_idx);
      console.log(selectStudyInfo);
      setSelectClassStudyInfo({dates:selectStudyInfo.cs_date,index:selectStudyInfo.cs_index});
      //원생 삭제 표시
      if(remainDays(selectStudyInfo.cs_date) > 0 && selectStudyInfo.childrens.length > 0) {
        setCanDeleteChildren(true);
      } else {
        setCanDeleteChildren(false);
      }
    } 
    //선택된 수업차수정보를 작업할 정보객체로 변경
  }

  //원생추가
  const onAddChildrensInStudyHandler = (e) => {
    const selectStudyInfo = varClassStudyList.find(el=>el.cs_idx === varClassStudyIndex);
    console.log(selectStudyInfo,varClassStudyIndex);
    let classStudyIndex = varClassStudyIndex;
    if(isNull(selectStudyInfo) || varClassStudyIndex === 0) {
      alert(`원생을 추가할 차수를 먼저 선택하세요.`);
      return;
    } else {
      if(remainDays(selectStudyInfo.cs_date) < 0) {
        alert(`${selectStudyInfo.cs_index}차수업은 이미 진행된 수업이므로 원생 현황을 변동할 수 없습니다.`);
        return;
      }
    }
    //수업차수고유번호,수업참여형태: 정규/보강/참여 
    navigate(`/Branch/StudyChildrenAdd/${classStudyIndex}/${varClassStudyType}`);
  }

  //삭제할 원생 선택
  const onSelectChildrenStudyHandler = (e,findChildrenData) => {
    const bchecked = e.currentTarget.checked;
    console.log(findChildrenData);
    //해당 수업차수에 해당하는 원생찾기
    const cs_index = findChildrenData.cs_index; //선택된 차수***
    const csc_idx = findChildrenData.csc_idx;
    const ch_idx = findChildrenData.ch_idx; 
    const ch_name = findChildrenData.ch_name;
    console.log(findChildrenData,varDeleteChildrenList);

    let checkAll = false;
    let sprompt = `원생(${ch_name})의 수업삭제를 위해 선택한 차수이후의 모든 수업을 선택합니까?`;
    if(varClassStudyType === 0) sprompt = `원생(${ch_name})의 수업이동을 위해 선택한 차수이후의 모든 수업을 선택합니까?`
    if(window.confirm(sprompt)) checkAll = true;

    //원생검색
    const childrenList = [...varClassChildrenList];
    const childrenIndex = childrenList.findIndex(el=>el.ch_idx===ch_idx);
    
    //삭제할 원생 배열 재조정
    const findIndex = varDeleteChildrenList.findIndex(el=>el.csc_idx===csc_idx); 
    if(bchecked) {  //선택
      console.log(findIndex,checkAll);

      //정규수업의 경우 1명만 선택 가능 - 점검
      if(varClassStudyType === 0) {
        if(varDeleteChildrenList.length > 0) {
          if(varDeleteChildrenList[0].ch_idx !== ch_idx) {
            e.currentTarget.checked = false;
            alert('수업이동은 1명만 선택이 가능합니다.'); return false;
          }
        }
      }

      if(findIndex === -1 && !checkAll) {  //현재 선택된 배열에서 없으면 추가
        const newItem = {index:findChildrenData.cs_index,ch_idx:findChildrenData.ch_idx,csc_idx:csc_idx,clc_ph_idx:findChildrenData.clc_ph_idx};
        setDeleteChildrenList(varDeleteChildrenList.concat(newItem));
        //보유수량 추가
        if(childrenIndex >= 0) childrenList[childrenIndex].smc_store++;
      } else {
        //일단 선택된 원생의 수업을 제외
        let newList = varDeleteChildrenList.filter(el=>el.ch_idx !== ch_idx); 
        //선택한 차수이후의 모든 수업을 추가
        for(var i=0; i < varClassStudyList.length; i++) {
          let childrens = varClassStudyList[i].childrens;
          for(var j=0; j < childrens.length; j++) {
            let childs = childrens[j];
            if(childs.ch_idx === ch_idx && childs.cs_index >= cs_index && (childs.csc_status===1 || childs.csc_status===-1)) {
              let csc_idx = childs.csc_idx;
              let cs_index = childs.cs_index;
              let clc_ph_idx = childs.clc_ph_idx;
              const newItem = {index:cs_index,ch_idx:ch_idx,csc_idx:csc_idx,clc_ph_idx:clc_ph_idx};
              newList.push(newItem);
              if(childrenIndex >= 0) childrenList[childrenIndex].smc_store++;
              break;
            }
          }
        }
        setDeleteChildrenList(newList);
      }
    } else {  //선택제외
      if(findIndex > -1 && !checkAll) { //선택된 수업만
        const copyList = varDeleteChildrenList.filter(el=>el.csc_idx !== csc_idx);
        setDeleteChildrenList(copyList);
        if(childrenIndex >= 0) childrenList[childrenIndex].smc_store--;
      } else {  //모든수업에서
        //차감된 수량 복구
        if(childrenIndex >= 0) {
          const returnList = varDeleteChildrenList.filter(el=>el.ch_idx===ch_idx);
          childrenList[childrenIndex].smc_store = childrenList[childrenIndex].smc_store - returnList.length;
        }
        //복구
        const newList = varDeleteChildrenList.filter(el=>el.ch_idx !== ch_idx);
        setDeleteChildrenList(newList);
      }
    }
    //최종 재등록
    setClassChildrenList(childrenList);
  }

  //원생삭제
  const onDeleteChildrensInStudyHandler = async(e) => {
    //console.log(varDeleteChildrenList,varClassStudyChildrenList);
    //수업차수에 등록된 원행이 모두 삭제되는 경우 클래스에 등록된 원생을 삭제하기 위헤 정리
    let delList = [];
    let childrens = [...varClassStudyChildrenList]; //점검할 클래스의 원생번호 배열

    //삭제할 원생의 고유번호만 배열로 저장
    for(var i=0; i < varDeleteChildrenList.length; i++) {
      let csc_idx = varDeleteChildrenList[i].csc_idx;
      if(isNull(csc_idx)) continue;
      let ch_idx = varDeleteChildrenList[i].ch_idx;
      if(delList.indexOf(ch_idx) === -1) {  //삭제 점검할 원생번호의 중복을 피하기 위해 --> 중복이 아니면
        delList.push(ch_idx);  //삭제 점검할 원생번호 배열로 저장
      } 
      //삭제하기로 한 선택된 수업차수의 원생정보를 전체 정보에서 삭제
      childrens = childrens.filter(el=>el.csc_idx !== csc_idx); 
    }

    //console.log(delList,childrens);
    //삭제할 클래스의 원생목록 구성
    let delChildrens = [];
    for(var j=0; j < delList.length; j++) {
      let del_idx = delList[j]; //점검할 원생번호
      let findIndex = childrens.findIndex(el=>el.csc_ch_idx === del_idx); //남은 수업별 원생정보중에 선택된 원생의 다른 수업이 있는지 확인
      //console.log(del_idx,findIndex);
      if(findIndex === -1) {  //전체 수업에 등록된 원생이 없어진 경우
        delChildrens.push(del_idx); //클래스에서 원생의 등록을 삭제하기 위해 원생번호 배열로 저장
      }
    }

    const sendData = {cl_idx:cl_idx,dataList:varDeleteChildrenList,delList:delChildrens};

    if(!window.confirm('선택한 원생의 수업참여를 삭제하시겠습니까?')) return false;

    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_study_children`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        GetClassInformation();
      } else {
        alert(datas.message);
      }
    });
  }

  //수업이동페이지로
  const onMoveChildrensInStudyHandler = (e) => {
    if(varDeleteChildrenList.length === 0) {
      alert('클래스를 변경시킬 수업이 선택되어 있지 않습니다.'); return false;
    }
    const jsonString = JSON.stringify(varDeleteChildrenList);
    localStorage.setItem('move_study_information',jsonString);
    navigate(`/Branch/StudentChildrenMove/${cl_idx}`);
  }

  return isObjEmpty(varClassInfo)?null:(
    <div className="vh-content kids-center-wrap">
      <HeaderBranchTitle varPageTitle={'원생 설정'} varBackString={`/Branch/ClassInformation/${cl_idx}`}/>
      <div className="vh-content-body">
        <div className="kids-form-wrap">
          <div className="center-wrap">
            {/* 클래스정의 */}
            <div className="class-info-box">
              <div className="left">
                <img src={main01Icon} alt=""/>
                <span>{varClassInfo.cl_type===1?"마마몽떼":"플라이"}<br/>{varClassInfo.cr_name}</span>
              </div>
              <div className="txt-box">
                <p className="class-tit">{varClassInfo.sm_name}</p>
                <div className="cl-info-line flex">
                  <img src={class01Icon} alt=""/><p>{varClassInfo.cl_name}</p>
                </div>
                <div className="cl-info-line flex">
                  <img src={class03Icon} alt=""/><p>{ChangeSimpleDateString(varSelectClassStudyInfo.dates)}</p>
                </div>
                <div className="cl-info-line flex">
                  <img src={class02Icon} alt=""/><p style={{marginRight:"20px"}}>{`${varClassInfo.childrens}명 (정원 ${varClassInfo.cl_childrens}명)`}</p>
                  <img src={class04Icon} alt=""/><p>{varSelectClassStudyInfo.index===""?"":`${varSelectClassStudyInfo.index}차수업`}</p>
                </div>
              </div>
            </div>
            {/* 차수별 수업+원생 */}
            {varClassStudyList.length===0?null:
              <div className="class-list-wrap" style={{marginTop:"20px"}}>
                <div className="list-con">
                  <ul>
                    {varClassStudyList.map((studys,i)=>(
                      <li key={'study_'+i} className={studys.cs_idx===varClassStudyIndex?"on":""}>
                        <ClassStudyChildrens varClassStudyIndex={varClassStudyIndex} varClassStudyInfo={studys} varMainClassStudyType={varMainClassStudyType}
                          varClassStudyType={varClassStudyType} setClassStudyType={setClassStudyType} varDeleteChildrenList={varDeleteChildrenList}
                          onShowStudyInfoHandler={onShowStudyInfoHandler} varCanDeleteChildren={varCanDeleteChildren} onSelectChildrenStudyHandler={onSelectChildrenStudyHandler}/>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            }
            <div className="form-contoller bt-btn">
              {varClassStudyType===0?
                <button type="button" className="form-contoller-btn btn-yes" style={{width:"100%"}} onClick={e=>onMoveChildrensInStudyHandler(e)}>클래스변경</button>
              :
                <>
                  {varCanDeleteChildren &&  <button type="button" className="form-contoller-btn btn-no" onClick={e=>onDeleteChildrensInStudyHandler(e)}>원생 제외</button>}
                  <button type="button" className="form-contoller-btn btn-yes" style={!varCanDeleteChildren?{width:"100%"}:{}} onClick={e=>onAddChildrensInStudyHandler(e)}>원생 추가</button>
                </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>   
  );

}
export default StudyChildrenSet;